<mat-sidenav-container class="sidenav-container" hasBackdrop="false">
  <mat-sidenav #drawer mode="side" [opened]="true" [disableClose]="true" class="custom-sidenav">
    <div class="user-info">
      <mat-icon>account_circle</mat-icon>
      <div class="user-details">
        <span class="user-name">{{ displayName }}</span>
        <span class="user-email">{{ displayEmail }}</span>
      </div>
    </div>

    <mat-divider></mat-divider>

    <mat-nav-list>
      <a mat-list-item routerLink="/projects" routerLinkActive="active-link" (click)="resetTimesheetLinesFilters(); resetProjectFilters()">
        <span class="navigation-link"><mat-icon>work</mat-icon>Projects</span>
      </a>
      <a mat-list-item routerLink="/timesheets" routerLinkActive="active-link" class="navigation-link">
        <span class="navigation-link"><mat-icon>schedule</mat-icon>Timesheet</span>
      </a>
      <a mat-list-item routerLink="/zoho-books" routerLinkActive="active-link">
        <span class="navigation-link"><mat-icon>book</mat-icon>Zoho Books</span>
      </a>
      @if (isProjectManager()) {
        <a mat-list-item routerLink="/reporting" routerLinkActive="active-link">
          <span class="navigation-link"><mat-icon>bar_chart</mat-icon>Reporting</span>
        </a>
        <a mat-list-item routerLink="/zoho-setup" routerLinkActive="active-link">
          <span class="navigation-link"><mat-icon>settings</mat-icon>Zoho Setup</span>
        </a>
        <a mat-list-item routerLink="/bc-sync" routerLinkActive="active-link">
          <span class="navigation-link"><mat-icon>sync_alt</mat-icon>BC Sync</span>
        </a>
      }
    </mat-nav-list>

    <mat-divider></mat-divider>

    <mat-nav-list>
      <div class="logout-section">
        <button mat-list-item (click)="logout(); drawer.toggle()">
          <div class="logout-button">
            <mat-icon>logout</mat-icon>
            <span>Logout</span>
          </div>
        </button>
      </div>
    </mat-nav-list>
  </mat-sidenav>

  <mat-sidenav-content>
    <mat-toolbar color="primary">
      <button mat-icon-button (click)="drawer.toggle()">
        <mat-icon>menu</mat-icon>
      </button>
      <span>Timesheet</span>
    </mat-toolbar>

    <div class="content">
      <router-outlet></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
